import React, { useState, useEffect, Fragment } from "react";
import { useForm } from "react-hook-form";
import EditViewPage from "../EditViewPage";
import { ToastContainer } from "react-toastify";
import { saveAs } from "file-saver";
import { baseUrl } from "../../../../Constnats/constants";
// import "./RegistrationFormNew.css"; // Import the new CSS file
import Cloadupload from "../../../LandingPage/img/CloudImg.svg";
import downLoadAd from "../../../LandingPage/img/dwnloAdBtn.svg";
const agency = [
  { text: "In House", value: "I" },
  { text: "NIC", value: "N" },
  { text: "Others", value: "O" },
];

const RegistrationFormNew = ({
  selectedFile,
  setSelectedFile,
  setIsSubmitted,
  isSubmitted,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    trigger,
    reset,
  } = useForm({
    defaultValues: {
      orgtype: "",
      state: "",
      agencyType: "",
    },
  });

  const [realCaptcha, setRealCaptcha] = useState("");
  const [uid, setUid] = useState("");
  const [uploadStatus, setUploadStatus] = useState("");
  const [uploadError, setUploadError] = useState("");
  const [captchaError, setCaptchaError] = useState("");
  const [message] = useState("");
  const [isFileUpload, setIsFileUpload] = useState(false);
  const [showOtherField, setShowOtherField] = useState(false);
  const [showOtherAgency, setShowOtherAgency] = useState(false);
  const [showNicFields, setshowNicFields] = useState(false);
  const [captchaText, setCaptchaText] = useState("");
  const [filledData, setFilledData] = useState({});
  const [stateList, setStates] = useState([]);
  const [organizationType, setOrgType] = useState([]);

  useEffect(() => {
    fetchCaptcha();
    getStatesAndOrganizationType();
    scrollToTop();
  }, []);

  const handleOrganizationTypeChange = (e) => {
    setShowOtherField(
      e.target.options[e.target.selectedIndex].text === "Others"
    );
  };

  const handleAgencyType = (e) => {
    setShowOtherAgency(e.target.options[e.target.selectedIndex].value === "O");
    setshowNicFields(e.target.options[e.target.selectedIndex].value === "N");
  };

  const fetchCaptcha = async () => {
    try {
      const response = await fetch(`${baseUrl}/register`);
      const data = await response.json();
      setRealCaptcha("data:image/png;base64," + data.message);
      setUid(data.uid);
      setCaptchaText(data.captcha);
    } catch (error) {}
  };

  const getStatesAndOrganizationType = () => {
    fetch(`${baseUrl}/getStates`, { method: "POST" })
      .then((response) => response.json())
      .then((json) => setStates(json));
    fetch(`${baseUrl}/getOrganizationTypes`, { method: "POST" })
      .then((response) => response.json())
      .then((json) => setOrgType(json));
  };

  const [pdfData, setPdfData] = useState(null);
  const handleUploadFile = (e) => {
    const file = e.target.files[0];
    setSelectedFile(file);
    setUploadError("");
    const reader = new FileReader();
    reader.onload = (e) => {
      setPdfData(e.target.result);
    };
    reader.readAsDataURL(file);
  };

  const handleUploadFileSubmission = async (e) => {
    e.preventDefault();
    if (selectedFile) {
      if (selectedFile.size > 500 * 1024) {
        setUploadError("PDF should be less than 500 KB");
        setUploadStatus("");
      } else {
        setUploadStatus("Uploaded the file successfully");
        setIsFileUpload(true);
        setUploadError("");
      }
    } else {
      setUploadError("Failed to upload file");
      setUploadStatus("");
    }
  };

  const onSubmit = async (data) => {
    if (!selectedFile) {
      setUploadError("Please select a file to upload.");
      return;
    }
    if (!isFileUpload) {
      setUploadError("Please click upload button.");
      return;
    }
    let captchaTyped = document.getElementById("captcha").value;
    if (captchaTyped !== captchaText) {
      setCaptchaError("Invalid Captcha");
      return;
    } else {
      setCaptchaError("");
    }
    const isValid = await trigger();
    if (isValid) {
      setIsSubmitted(true);
      setFilledData(data);
    }
  };

  const handleDownload = async (e) => {
    e.preventDefault();
    const url = `${baseUrl}/download/nicdsign.pdf`;
    try {
      const response = await fetch(url, { method: "GET" });
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const blob = await response.blob();
      saveAs(blob, "NICDSign-TermsofUsage.pdf");
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  const scrollToTop = () => {
    const element = document.getElementById("requestForm");
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <Fragment>
      <ToastContainer />
      {isSubmitted ? (
        <div className="registration-form-wrapper">
          <EditViewPage
            data={filledData}
            organizationType={organizationType}
            stateList={stateList}
            realCaptcha={realCaptcha}
            selectedFile={selectedFile}
            pdfData={pdfData}
            setSelectedFile={setSelectedFile}
            setPdfData={setPdfData}
            setIsSubmitted={setIsSubmitted}
            uid={uid}
            reset={reset}
            setUploadStatus={setUploadStatus}
            setShowOtherField={setShowOtherField}
            setShowOtherAgency={setShowOtherAgency}
            setshowNicFields={setshowNicFields}
            isSubmitted={isSubmitted}
          />
        </div>
      ) : (
        <div
          className="registration-form-wrapper form form-padding"
          id="requestForm"
        >
          <div className=" d-flex justify-content-center w-100">
            <div className="col-md-8 additionalStyle">
              <form className="form-body" onSubmit={handleSubmit(onSubmit)}>
                <div className="firstPart">
                  <div className="subHeading">
                    <div>
                      <label>Organization details</label>
                    </div>
                  </div>
                  <div className={showOtherField ? "section1" : "section2"}>
                    <div className="form-group">
                      <label className="form__label" htmlFor="state">
                        Organization Type
                      </label>
                      <select
                        className={`form__input selectStyle ${
                          errors.orgname ? "error-border" : ""
                        }`}
                        id="orgtype"
                        {...register("orgtype", {
                          required: "Organization Type required*",
                        })}
                        onChange={handleOrganizationTypeChange}
                      >
                        <option value="" disabled hidden className="selecOpt">
                          Choose Organization Type
                        </option>
                        {organizationType.map((type) => (
                          <option key={type.id} value={type.id}>
                            {type.type}
                          </option>
                        ))}
                      </select>
                      {errors.orgtype && (
                        <div className="error">{errors.orgtype.message}</div>
                      )}
                    </div>
                    {showOtherField && (
                      <div className="form-group">
                        <label className="form__label" htmlFor="othertype">
                          If Others (specify)
                        </label>
                        <input
                          className={`form__input ${
                            errors.othertype ? "error-border" : ""
                          }`}
                          type="text"
                          id="othertype"
                          placeholder="Specify other type"
                          {...register("othertype", {
                            required: "Please specify if Others is selected*",
                          })}
                          onBlur={() => trigger("othertype")}
                        />
                        {errors.othertype && (
                          <div className="error">
                            {errors.othertype.message}
                          </div>
                        )}
                      </div>
                    )}
                    <div className="form-group">
                      <label className="form__label" htmlFor="OName">
                        Organization Name
                      </label>
                      <input
                        className={`form__input ${
                          errors.orgname ? "error-border" : ""
                        }`}
                        type="text"
                        id="OName"
                        placeholder="Organization name"
                        {...register("orgname", {
                          required: "Organization Name required*",
                        })}
                        onBlur={() => trigger("orgname")}
                      />
                      {errors.orgname && (
                        <div className="error">{errors.orgname.message}</div>
                      )}
                    </div>
                  </div>
                  <div className="section">
                    <div className="form-group">
                      <label className="form__label" htmlFor="OAddress">
                        Organization Address
                      </label>
                      <textarea
                        className={`form__input ${
                          errors.orgaddress ? "error-border" : ""
                        }`}
                        rows="3"
                        cols="32"
                        id="orgaddress"
                        placeholder="Organization Address"
                        {...register("orgaddress", {
                          required: "Organization Address required*",
                        })}
                        onBlur={() => trigger("orgaddress")}
                      />
                      {errors.orgaddress && (
                        <div className="error">{errors.orgaddress.message}</div>
                      )}
                    </div>
                  </div>
                  <div className="section2">
                    <div className="form-group">
                      <label className="form__label" htmlFor="state">
                        State
                      </label>
                      <select
                        className={`form__input selectStyle ${
                          errors.orgname ? "error-border" : ""
                        }`}
                        id="state"
                        {...register("state", { required: "State required*" })}
                      >
                        {/* 'selected' keyword is removed from this line */}
                        <option value="" disabled hidden className="selecOpt">
                          Choose state
                        </option>

                        {stateList.map((state) => (
                          <option key={state.stateCode} value={state.stateCode}>
                            {state.stateName}
                          </option>
                        ))}
                      </select>
                      {errors.state && (
                        <div className="error">{errors.state.message}</div>
                      )}
                    </div>
                    <div className="form-group">
                      <label className="form__label" htmlFor="Department">
                        Ministry/ Department
                      </label>
                      <input
                        className={`form__input ${
                          errors.deptname ? "error-border" : ""
                        }`}
                        type="text"
                        id="Department"
                        placeholder="Department"
                        {...register("deptname", {
                          required: "Department required*",
                        })}
                        onBlur={() => trigger("deptname")}
                      />
                      {errors.deptname && (
                        <div className="error">{errors.deptname.message}</div>
                      )}
                    </div>
                  </div>
                  <div className="section2">
                    <div className="form-group">
                      <label className="form__label" htmlFor="Head">
                        Head of Organization
                      </label>
                      <input
                        className={`form__input ${
                          errors.orghead ? "error-border" : ""
                        }`}
                        type="text"
                        id="Head"
                        placeholder="Head of Organization"
                        {...register("orghead", {
                          required: "Head of Organization required*",
                        })}
                        onBlur={() => trigger("orghead")}
                      />
                      {errors.orghead && (
                        <div className="error">{errors.orghead.message}</div>
                      )}
                    </div>
                    <div className="form-group">
                      <label className="form__label" htmlFor="phone">
                        Office Phone No
                      </label>
                      <input
                        className={`form__input ${
                          errors.phoneno ? "error-border" : ""
                        }`}
                        type="text"
                        id="phone"
                        placeholder="Phone No"
                        {...register("phoneno", {
                          required: "Phone No is required*",
                          pattern: {
                            value: /^\d{8,12}$/,
                            message:
                              "Phone No must have minimum 8 digits ,maximum 12 digits. ",
                          },
                        })}
                        onBlur={() => trigger("phoneno")}
                      />
                      {errors.phoneno && (
                        <div className="error">{errors.phoneno.message}</div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="secondPart">
                  <div className="subHeading">
                    <div>
                      <label>Project details</label>
                    </div>
                  </div>
                  <div className="section">
                    <div className="form-group">
                      <label className="form__label" htmlFor="ProjectName">
                        Project Name
                      </label>
                      <input
                        className={`form__input ${
                          errors.projectname ? "error-border" : ""
                        }`}
                        type="text"
                        id="ProjectName"
                        placeholder="Project Name"
                        {...register("projectname", {
                          required: "Project Name required*",
                        })}
                        onBlur={() => trigger("projectname")}
                      />
                      {errors.projectname && (
                        <div className="error">
                          {errors.projectname.message}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="section">
                    <div className="form-group">
                      <label className="form__label" htmlFor="projectdesc">
                        Brief description of the project
                      </label>
                      <textarea
                        className={`form__input ${
                          errors.projectdesc ? "error-border" : ""
                        }`}
                        rows="3"
                        cols="32"
                        id="projectdesc"
                        placeholder="Brief Description"
                        {...register("projectdesc", {
                          required: "Brief Description required*",
                        })}
                        onBlur={() => trigger("projectdesc")}
                      />
                      {errors.projectdesc && (
                        <div className="error">
                          {errors.projectdesc.message}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="thirdPart">
                  <div className="subHeading">
                    <div>
                      <label>Nodal officer details</label>
                    </div>
                  </div>
                  <div className="section2">
                    <div className="form-group">
                      <label className="form__label" htmlFor="nodalofficer">
                        Name
                      </label>
                      <input
                        className={`form__input ${
                          errors.nodalofficer ? "error-border" : ""
                        }`}
                        type="text"
                        id="nodalofficer"
                        placeholder="Name"
                        {...register("nodalofficer", {
                          required: "Name required*",
                        })}
                        onBlur={() => trigger("nodalofficer")}
                      />
                      {errors.nodalofficer && (
                        <div className="error">
                          {errors.nodalofficer.message}
                        </div>
                      )}
                    </div>
                    <div className="form-group">
                      <label className="form__label" htmlFor="nodaldesignation">
                        Designation
                      </label>
                      <input
                        className={`form__input ${
                          errors.nodaldesignation ? "error-border" : ""
                        }`}
                        type="text"
                        id="nodaldesignation"
                        placeholder="Designation"
                        {...register("nodaldesignation", {
                          required: "Nodal Officer required*",
                        })}
                        onBlur={() => trigger("nodaldesignation")}
                      />
                      {errors.nodaldesignation && (
                        <div className="error">
                          {errors.nodaldesignation.message}
                        </div>
                      )}
                    </div>
                    <div className="form-group">
                      <label className="form__label" htmlFor="mob">
                        Contact Number
                      </label>
                      <input
                        className={`form__input ${
                          errors.mobileno ? "error-border" : ""
                        }`}
                        type="text"
                        id="mob"
                        placeholder="Contact Number"
                        {...register("mobileno", {
                          required: "Contact Number is required*",
                          pattern: {
                            value: /^\d{8,12}$/,
                            message:
                              "Contact Number must have minimum 8 digits ,maximum 12 digits",
                          },
                        })}
                        onBlur={() => trigger("mobileno")}
                      />
                      {errors.mobileno && (
                        <div className="error">{errors.mobileno.message}</div>
                      )}
                    </div>
                    <div className="form-group">
                      <label className="form__label" htmlFor="email">
                        Email
                      </label>
                      <input
                        className={`form__input ${
                          errors.email ? "error-border" : ""
                        }`}
                        type="email"
                        id="email"
                        placeholder="Enter Email ending with gov.in / nic.in"
                        {...register("email", {
                          required: "Email required*",
                          pattern: {
                            value:
                              /^[a-zA-Z0-9._%+-]+@([a-zA-Z0-9-]+\.)*(gov\.in|nic\.in)$/i,
                            message:
                              "Invalid email address. Only 'gov.in' and 'nic.in' domains are allowed.",
                          },
                        })}
                        onBlur={() => trigger("email")}
                      />
                      {errors.email && (
                        <div className="error">{errors.email.message}</div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="additionalPart">
                  <div className="subHeading">
                    <div>
                      <label>Software Development Agency</label>
                    </div>
                  </div>
                  <div
                    className={
                      showOtherAgency || showNicFields ? "section2" : "section"
                    }
                  >
                    <div className="form-group">
                      <label className="form__label" htmlFor="agencyType">
                        Agency type
                      </label>
                      <select
                        className={`form__input selectStyle ${
                          errors.agencyType ? "error-border" : ""
                        }`}
                        id="agencyType"
                        {...register("agencyType", {
                          required: "Agency required*",
                        })}
                        onChange={handleAgencyType}
                      >
                        {/* 'selected' keyword is removed from this option */}
                        <option value="" disabled hidden className="selecOpt">
                          Choose Agency type
                        </option>
                        {agency.map((object) => (
                          <option key={object.value} value={object.value}>
                            {object.text}
                          </option>
                        ))}
                      </select>
                      {errors.agencyType && (
                        <div className="error">{errors.agencyType.message}</div>
                      )}
                    </div>
                    {showOtherAgency && (
                      <div className="form-group">
                        <label className="form__label" htmlFor="otheragency">
                          If Others (specify)
                        </label>
                        <input
                          className={`form__input ${
                            errors.otheragency ? "error-border" : ""
                          }`}
                          type="text"
                          id="otheragency"
                          placeholder="Other Agency Name"
                          {...register("otheragency", {
                            required:
                              "Please specify if Other Agency  is selected*",
                          })}
                          onBlur={() => trigger("otheragency")}
                        />
                        {errors.otheragency && (
                          <div className="error">
                            {errors.otheragency.message}
                          </div>
                        )}
                      </div>
                    )}
                    {showNicFields && (
                      <div className="form-group">
                        <label className="form__label" htmlFor="niccontactname">
                          NIC Contact Person Name
                        </label>
                        <input
                          className={`form__input ${
                            errors.niccontactname ? "error-border" : ""
                          }`}
                          type="text"
                          id="niccontactname"
                          placeholder="Name"
                          {...register("niccontactname", {
                            required: "Name required*",
                          })}
                          onBlur={() => trigger("niccontactname")}
                        />
                        {errors.niccontactname && (
                          <div className="error">
                            {errors.niccontactname.message}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                  <div>
                    {" "}
                    <br></br>
                  </div>
                  {showNicFields && (
                    <div className="section1">
                      <div className="form-group">
                        <label className="form__label" htmlFor="niccontactno">
                          NIC Contact Person Mobile
                        </label>
                        <input
                          className={`form__input ${
                            errors.niccontactno ? "error-border" : ""
                          }`}
                          type="text"
                          id="niccontactno"
                          placeholder="Contact Number"
                          {...register("niccontactno", {
                            required: "Contact Number is required*",
                            pattern: {
                              value: /^\d{8,12}$/,
                              message:
                                "Contact Number must have minimum 8 digits ,maximum 12 digits",
                            },
                          })}
                          onBlur={() => trigger("niccontactno")}
                        />
                        {errors.niccontactno && (
                          <div className="error">
                            {errors.niccontactno.message}
                          </div>
                        )}
                      </div>
                      <div className="form-group">
                        <label
                          className="form__label"
                          htmlFor="niccontactemail"
                        >
                          NIC Contact Person Email
                        </label>
                        <input
                          className={`form__input ${
                            errors.niccontactemail ? "error-border" : ""
                          }`}
                          type="email"
                          id="niccontactemail"
                          placeholder="Enter Email ending with gov.in / nic.in"
                          {...register("niccontactemail", {
                            required: "Email required*",
                            pattern: {
                              value:
                                /^[a-zA-Z0-9._%+-]+@([a-zA-Z0-9-]+\.)*(gov\.in|nic\.in)$/i,
                              message:
                                "Invalid email address. Only 'gov.in' and 'nic.in' domains are allowed.",
                            },
                          })}
                          onBlur={() => trigger("niccontactemail")}
                        />
                        {errors.niccontactemail && (
                          <div className="error">
                            {errors.niccontactemail.message}
                          </div>
                        )}
                      </div>
                      <div className="form-group">
                        <label className="form__label" htmlFor="niccontactdesg">
                          NIC Contact Person Designation
                        </label>
                        <input
                          className={`form__input ${
                            errors.niccontactdesg ? "error-border" : ""
                          }`}
                          type="text"
                          id="niccontactdesg"
                          placeholder="Designation"
                          {...register("niccontactdesg", {
                            required: "Designation required*",
                          })}
                          onBlur={() => trigger("niccontactdesg")}
                        />
                        {errors.niccontactdesg && (
                          <div className="error">
                            {errors.niccontactdesg.message}
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
                <div> </div>
                <div className="section">
                  <div className="form-group pt">
                    <div>
                      <label className="form__label" htmlFor="upload">
                        Upload copy of Terms of Usage (TOU) for NICDSign
                      </label>
                      <div className="dwnlsection1">
                        <div className="dwnloAdDiv">
                          <p className="styleP">
                            Download the Terms of Use (TOU) for NICDSign (
                            <span
                              className="dwnlodLinkWrap"
                              onClick={handleDownload}
                            >
                              <span className="donlodLink"> from here</span>
                              <img
                                className="dwnloadLinkBtn"
                                src={downLoadAd}
                                alt=""
                              />
                            </span>
                            ), fill it out, and upload the scanned copy.
                          </p>
                        </div>
                        <div className="uploadFileD">
                          <input
                            className={`form__input formUpdate ${
                              uploadError ? "error-border" : ""
                            }`}
                            type="file"
                            id="upload"
                            onChange={handleUploadFile}
                            accept=".PDF,.pdf"
                            style={{ display: "none" }}
                          />
                          <label
                            htmlFor="upload"
                            className={`customFileUpload ${
                              uploadError ? "doterror-border" : ""
                            }`}
                          >
                            {selectedFile ? (
                              <div className="afterSelct">
                                {selectedFile.name}
                              </div>
                            ) : (
                              <div>
                                <div className="cloudDwnld">
                                  <img src={Cloadupload} alt="uploadimg" />
                                </div>
                                <span className="selctFile">
                                  Select files here
                                </span>
                              </div>
                            )}
                          </label>
                          {uploadStatus && (
                            <div className="status-msg">{uploadStatus}</div>
                          )}
                          {uploadError && (
                            <div className="error">{uploadError}</div>
                          )}
                        </div>
                        <button
                          className={!selectedFile ? "disableBtn" : "Uploadbtn"}
                          onClick={handleUploadFileSubmission}
                          disabled={!selectedFile}
                        >
                          Upload
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="form-group pt">
                    <label className="form__label" htmlFor="captcha">
                      Captcha
                    </label>
                    <div className="captachaAlgn">
                      <img
                        src={realCaptcha}
                        alt="Captchaimage"
                        className="styleImg"
                      />
                      <input
                        className={`form__input captchaimg ${
                          errors.captcha || captchaError ? "error-border" : ""
                        }`}
                        type="text"
                        id="captcha"
                        placeholder="Enter Captcha"
                        {...register("captcha", {
                          required: "Captcha required*",
                        })}
                        onBlur={() => trigger("captcha")}
                      />
                    </div>
                    {errors.captcha && (
                      <div className="error">{errors.captcha.message}</div>
                    )}
                    {captchaError && (
                      <div className="error">Invalid Captcha</div>
                    )}
                  </div>
                </div>
              </form>
              <div className="footer">
                <button
                  className="form__button btn2"
                  type="button"
                  onClick={handleSubmit(onSubmit)}
                >
                  Save
                </button>
              </div>
              {message && <div className="status-msg">{message}</div>}
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default RegistrationFormNew;
